import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TipoPromocaoCampanha, tiposPromocoes } from '../tipo-promocao-campanha';

@Component({
    selector: 'sgt-tipo-promocao-campanha-select',
    templateUrl: './tipo-promocao-campanha-select.component.html',
    styleUrls: ['./tipo-promocao-campanha-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TipoPromocaoCampanhaSelectComponent), multi: true },
    ]
})
export class TipoPromocaoCampanhaSelectComponent {
    /** ID do tipo de promoção da campanha */
    @Input() ngModel: number;
    /** Ao alterar o tipo de promoção da campanha*/
    @Output() ngModelChange = new EventEmitter<number>();

    /** Tipos de promoções da campanha disponíveis no select */
    @Input() tipos: TipoPromocaoCampanha[] = tiposPromocoes;

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    /** Ao alterar a situação do pacote de campanha */
    onChange(id: number) {
        this.ngModel = id;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
